module.exports = __webpack_public_path__ + "media/img/uploads/atak-mil-product-thumb-03-e1bae92636aa132f71a8de80cba46a40.png";